@if (scormUrl) {
  <iframe #scormFrame iframe [src]="scormUrl" width="100%" height="600px"
  (load)="onIframeLoad(scormFrame)"></iframe>
}
